<template>
  <div class="FootprintComponent">
    <!-- <span v-if="!isMPN">
      <b-list-group v-for="item in selectedFootprints" :key="item.footprintId" size="sm">
        <b-list-group-item v-if="selectedFootprints.length > 0" class="flex-column align-items-start"
          :variant="variant">
          <b-row>
            <b-col cols="2">
              <div :id="'place_svg_footprint__'+item.footprintId" class="image-footprint"></div>
            </b-col>
            <b-col cols="8">
              <p>{{item.name}}</p>
            </b-col>

          </b-row>
        </b-list-group-item>

      </b-list-group>
      <br>
      <p>{{lang.infotext_1}}:</p><br>
      <FootprintTableComponent :reloadTable="reloadTable" :lang="lang.table_Footprints"></FootprintTableComponent>
      <br>
      <span v-if="!appConf.status.isLM">
        <hr>
        <p>{{lang.infotext_2}}:</p>
        <b-form inline>

          <b-form-input id="input-footprint-name" class="input-footprint-name" :state="inputStatus" size="sm"
            v-model="footprintName" :placeholder="lang.placeholder_Create" aria-describedby="input-footprint-feedback">
          </b-form-input>

          <b-form-file v-model="file" :state="Boolean(file)" :placeholder=lang.placeholder_file
            drop-placeholder="Drop file here..." class="import-file" accept=".svg" size="sm"></b-form-file>

          <b-button class="btn create-button" size="sm" @click="createFootprint" :variant="variant">
            {{lang.button_Create}}</b-button>
          <b-form-invalid-feedback id="input-footprint-feedback">
            {{lang.validinfo_1}}
          </b-form-invalid-feedback>



        </b-form>
      </span>
    </span> -->

    <b-tabs v-model="tabIndex" card>

      <b-tab :title="lang.tab_Footprints" :title-link-class="textColors" :title-item-class="textColors" active>

        <!-- <b-form-input size="sm" v-model="selectedFootprints" disabled></b-form-input>   -->
        <b-list-group v-for="item in selectedFootprints" :key="item.footprintId" size="sm">
          <b-list-group-item v-if="selectedFootprints.length > 0" class="flex-column align-items-start"
            :variant="variant">
            <b-row>
              <b-col cols="2">
                <div :id="'place_svg_footprint__'+item.footprintId" class="image-footprint"></div>
              </b-col>
              <b-col cols="8">
                <p>{{item.name}}</p>
              </b-col>

            </b-row>
          </b-list-group-item>

        </b-list-group>
        <br>
        <p>{{lang.infotext_1}}:</p><br>
        <FootprintTableComponent :reloadTable="reloadTable" :lang="lang.table_Footprints"></FootprintTableComponent>
        <br>
        <span v-if="!appConf.status.isLM">
          <hr>
          <p>{{lang.infotext_2}}:</p>
          <b-form inline>

            <b-form-input id="input-footprint-name" class="input-footprint-name" :state="inputStatus" size="sm"
              v-model="footprintName" :placeholder="lang.placeholder_Create"
              aria-describedby="input-footprint-feedback">
            </b-form-input>

            <b-form-file v-model="file" :state="Boolean(file)" :placeholder=lang.placeholder_file
              drop-placeholder="Drop file here..." class="import-file" accept=".svg" size="sm"></b-form-file>

            <b-button class="btn create-button" size="sm" @click="createFootprint" :variant="variant">
              {{lang.button_Create}}</b-button>
            <b-form-invalid-feedback id="input-footprint-feedback">
              {{lang.validinfo_1}}
            </b-form-invalid-feedback>



          </b-form>
        </span>
      </b-tab>
      
      <b-tab v-if="globalSettings.requests" :title="lang.tab_LibraryRequest" :title-link-class="textColors" :title-item-class="textColors">
        <LibraryRequestComponent :item="part" :lang="lang.LibraryRequest" source="footprint"></LibraryRequestComponent>
      </b-tab>
      <b-tab v-if="isUL && isMPN" :title="lang.tab_UltraLibrarian" :title-link-class="textColors" :title-item-class="textColors">

        <LibraryULComponent :item="part" :lang="lang.LibraryUL" source="footprint"></LibraryULComponent>
      </b-tab>
    </b-tabs>

  </div>
</template>

<script>

import FootprintTableComponent from "@/components/shared/FootprintTableComponent"
import LibraryULComponent from "@/components/shared/LibraryULComponent"
import LibraryRequestComponent from '@/components/shared/LibraryRequestComponent'
import { mapGetters } from 'vuex'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
  name: 'FootprintComponent',
  components: {
    FootprintTableComponent,
    LibraryULComponent,
    LibraryRequestComponent
  },
  props:{
    lang: Object,
    selected: String
    
  },
  data () {
    return {
      footprintName: "",
      inputStatus: null,
      reloadTable: false,
      file: null,
      isMPN: false,
      mpn: {},
      isUL: false,
      part: {},
      tabIndex: 0
    }
  },
  computed: {
    ...mapGetters([
      'appConf',
      'globalSettings'
    ]),
    selectedFootprints(){
      if (this.$store.getters.selectedFootprints.length == 0){
        return [];
      }
      return this.$store.getters.selectedFootprints;
    },
    variant(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return "light";
      }else{
        return "dark";
      }
      
    },
    textColors() {
      if (this.$store.getters.s_skinVariant == "dark") {
        return ['tabs-bg-dark', 'tabs-text-light']
      } else {
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    },
    

  },
  created() {

    this.checkIfMPN();

    this.$store.dispatch(this.$store.getters.sectionPrefix + "_deleteSelectedFootprint");

    let vue = this;
          
    if (this.selected != "" && this.selected != undefined){
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getFootprints')
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){
          
          
          let footprintId = "";
            
          for (let j = 0, lej = result.data.length; j < lej; j++){
              
              if (result.data[j].name == vue.selected.trim()){
                footprintId = result.data[j].symbolId;
                break;
              }

            }

            const obj = {
              name: vue.selected.trim(),
              footprintId: footprintId
            }
            vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_addSelectedFootprint", obj);
          


        }

      })
    }

    
    
    

  },
  updated() {
    
    this.getSvg();
  },
  watch: {
    selectedFootprints:function (newVal, oldVal) {
      
      this.selectedFootprint = newVal[0];
    },
    
    reloadTable: function (newVal, oldVal) {
      
      this.$nextTick(function () {
        
        if (newVal == true){
          this.reloadTable = false;
        }
      })
      
      
    },
    tabIndex: function (newVal) {

  
      const objModal = {};
        
      if (newVal == 0) {
        objModal.ok = false
        objModal.cancel = false
      
      } 
      if (newVal == 1) {
        objModal.ok = true
        objModal.cancel = false
      }
      if (newVal == 2) {
        objModal.ok = true
        objModal.cancel = false
      }
      

      this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
    }
  },
  methods: {
    switchTabIndex(index) {

      this.tabIndex = index

    },
    checkIfMPN() {

      let vue = this;

      //if (this.$store.getters.selectedRows.length > 0) {
        const obj = {
          partId: this.$route.query.id
        }
        this.$store.dispatch(this.$store.getters.sectionPrefix + '_getPhysicals', obj)
          .then((result) => {
            console.log(result)
            if (result.status == "OK") {
              if (result.data.length > 0) {
                vue.isMPN = true;
                vue.mpn.ManufacturerName = result.data[0].ManufacturerName
                vue.mpn.ManufacturerPartNumber = result.data[0].ManufacturerPartNumber

                let obj = {
                  manufacturerName: vue.mpn.ManufacturerName,
                  manufacturerPartNumber: vue.mpn.ManufacturerPartNumber
                }

                this.$store.dispatch(this.$store.getters.sectionPrefix + '_findPart', obj)
                  .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                      if (result.data != null) {
                        vue.part = result.data;



                      } else {

                      }

                    }
                  })

              }

            }
          })
      //}

      this.$store.dispatch("getSearchEnginesBasic")
        .then((result) => {
          console.log(result)
          if (result.status == "OK") {
            if (result.data.length > 0) {
          
              for (let i = 0, lei = result.data.length; i < lei; i++) {
                  
                if (result.data[i].Name == "Ultra Librarian") {
                  vue.isUL = result.data[i].IsActive;
                }
                  
              }
              
                
            }
          }
        })
    
    },
    deleteItem(item){
      
      var newList = ""
      var temp = this.formProperty.split(",")
      for (var i = 0, le = temp.length; i < le; i++){
        
        if (temp[i] != item){
          var t = temp[i]
          newList += temp[i]
          if (i < le - 1){
            newList += ","
          }
        }
        

      }
      
      this.$store.commit('SETFORMPROPERTY', newList);

    },
    createFootprint(){
      
      if (this.footprintName != ""){
        let obj = {
          name: this.footprintName,
          
        }
        let vue = this;
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_createFootprint", obj)
            .then((result)=>{
              
              if(result.status == "OK"){

                if (vue.file != null){
                  const objFile = {
                    type: LibraryTypes.FOOTPRINT,
                    file: vue.file
                  }

                  vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_uploadSvg", objFile)
                  .then((result)=>{
                    console.log(result.data)



                  })
                }

                const obj = {
                  text: this.lang.alert_success_create_footprint,
                  time: 5,
                  type: "success"
                }

                this.$store.dispatch("displayFooterAlert", obj);

                vue.footprintName = "";
                vue.inputStatus = null;
                vue.reloadTable = true;

                let input = document.getElementById("input-footprint-name");

                input.setAttribute("class", "input-footprint-name");

                //todo reload table with footprints
              }else{
                const obj = {
                  text: this.lang.alert_error_create_footprint,
                  time: 10,
                  type: "danger"
                }

                this.$store.dispatch("displayFooterAlert", obj);
              }
        })


      }else{
        this.inputStatus = false;
      }



    },
    getSvg(){
      
      let vue = this;

      if (this.selectedFootprints[0] == undefined) {
        return
      }
      if (this.selectedFootprints[0].name == ""){
        return
      }
      for (let i = 0, lei = this.selectedFootprints.length; i < lei; i++){
        const obj = {
          type: LibraryTypes.FOOTPRINT,
          name: this.selectedFootprints[0].name,
          id: "place_svg_footprint__"+this.selectedFootprints[i].footprintId
        }
        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getSvg", obj)
        .then((result) => {
          
          if (result != null){
            
            
            let id = result.id;                          
            vue.loadSVG(result, id);
            
            
          }
        
        })
      }

      
    },
    async loadSVG(result, id){

      
      
      let place = document.getElementById(id);
   
      if (place != null) {
        if (result.noImage == false) {
          place.innerHTML = "";
          let svgData = await new Response(result).text();
          var parser = new DOMParser();
          var doc = parser.parseFromString(svgData, "image/svg+xml");
          doc.documentElement.setAttribute("width", 100);
          doc.documentElement.setAttribute("height", 100);
       
          place.appendChild(doc.documentElement);
        } else {
          place.innerHTML = "<p class=\"noimage\">No image</p>";
        }
      
      }
      
    },
  }
  
  
}
</script>


<style lang="scss">
  //@import "./../../scss/_modal.scss";
  .FootprintComponent{
  
    .list-group-item {
      padding: 0.25rem 0.25rem;


    }
    .create-button{
      margin-left: 10px;
    }
    .import-file{
      width: 400px;
      margin-left: 10px;
    

    }
    .input-footprint-name{
      width: 200px !important;
    }
    .image-footprint{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin: 5px;
      overflow: hidden;
      width: 100px;
      height: 100px;
      display: block;
      
    }
    .noimage {
      color: #333;
      margin: 20px;
      font-weight: bold;
    }
  }
  
  

</style>



// WEBPACK FOOTER //
// src/components/shared/FootprintComponent.vue